/* eslint-disable react/no-unknown-property */

/**
* ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
* See LICENSE for license details.
*
* @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
* @package scandipwa/base-theme
* @link https://github.com/scandipwa/base-theme
 */

import TextPlaceholder from 'Component/TextPlaceholder';
import SourceCategoryItemsCount from 'SourceComponent/CategoryItemsCount/CategoryItemsCount.component';
import { PagesType } from 'Type/ProductList.type';

/** @namespace Scandipwa/Component/CategoryItemsCount/Component */
export class CategoryItemsCountComponent extends SourceCategoryItemsCount {
    static propTypes = {
        ...super.propTypes,
        pages: PagesType
    };

    static defaultProps = {
        ...super.defaultProps,
        pages: []
    };

    renderItems() {
        const {
            totalItems,
            pages
        } = this.props;

        const promoTiles = [];
        Object.values(pages).map((page) => page.filter((product) => {
            if (typeof product === 'string') {
                promoTiles.push(product);
            }

            return product;
        }));

        return (
            <>
                <span block="CategoryItemsCount" elem="ItemsValue">{ totalItems - promoTiles.length }</span>
                <span block="CategoryItemsCount" elem="Label">
                    { ` ${ totalItems === 1 ? __('Item') : __('Items') }` }
                </span>
            </>
        );
    }

    render() {
        const {
            isMatchingListFilter
        } = this.props;

        return (
            <p block="CategoryPage" elem="ItemsCount">
                <TextPlaceholder
                  content={ isMatchingListFilter ? this.renderItems() : __('Products are loading...') }
                />
            </p>
        );
    }
}

export default CategoryItemsCountComponent;
